export var UserDeviceType;
(function (UserDeviceType) {
    UserDeviceType["MOBILE"] = "mobile";
    UserDeviceType["TABLET"] = "tablet";
    UserDeviceType["DESKTOP"] = "desktop";
})(UserDeviceType || (UserDeviceType = {}));
